module.exports = __webpack_public_path__ + "static/media/ordinary.f7a0f56b.png";